import { createStore, combineReducers } from 'redux';
import initialState from './initialState';
import offersReducer from './offersRedux';
// import aboutUsReducer from './aboutUsRedux';
import teamReducer from './teamRedux';

// const reducer = (state, action) => {
//   return state;
// };

const subreducers = {
  teams: teamReducer,
  offers: offersReducer,
  // aboutUs: aboutUsReducer,
};
// const initialState = {};
const reducer = combineReducers(subreducers);

const store = createStore(
  reducer,
  initialState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
export default store;
